'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStagedThread = loadStagedThread;

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _setCurrentChannel = require('../../actions/ConversationsActions/setCurrentChannel');

var _buildStubbedThread = require('../../threads/factories/buildStubbedThread');

var _addConversation = require('../../actions/ConversationsActions/addConversation');

var _resetStubbedThread = require('../../stubbed-thread-history/actions/resetStubbedThread');

var _updateView = require('../../current-view/actions/updateView');

var _views = require('../../current-view/constants/views');

function loadStagedThread() {
  return function (dispatch) {
    dispatch((0, _setCurrentChannel.setCurrentChannel)(_stubbedChannel.STUBBED_CHANNEL));

    dispatch((0, _resetStubbedThread.resetStubbedThread)());
    dispatch((0, _addConversation.addConversation)((0, _buildStubbedThread.buildStubbedThread)()));

    dispatch((0, _updateView.updateView)(_views.THREAD_VIEW));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/navigation/actions/loadStagedThread.js
// module id = 476
// module chunks = 2 3